var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowericon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "power_settings_new_24px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PowerIcon; Dark Color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 3H13V13H11V3ZM16.41 6.59L17.83 5.17C19.77 6.82 21 9.26 21 12C21 16.97 16.97 21 12 21C7.03 21 3 16.97 3 12C3 9.26 4.23 6.82 6.17 5.17L7.58 6.58C6.01 7.86 5 9.81 5 12C5 15.87 8.13 19 12 19C15.87 19 19 15.87 19 12C19 9.81 17.99 7.86 16.41 6.59Z",
    fill: "#EF3F3E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowericon);
export default __webpack_public_path__ + "static/media/powericon.219281f266e65054a943e724bb162c0a.svg";
export { ForwardRef as ReactComponent };